export default {
  title: "Programmation fondamentale",
  pageTitle: "Détails du Cours",
  parentTitle: "Cours",
};
